import { TimeUnit } from 'domain/Common';
import { mixed } from 'yup';

export const repeatIntervalTimeUnitSchema = mixed<TimeUnit>().oneOf(Object.values(TimeUnit)).default(TimeUnit.Weeks);
